import React, { useState } from 'react';
import get from 'lodash/get';
import { useSelector, useDispatch } from 'react-redux';

import { setUser } from '@store/auth/actions';
import { toggleModal, setStep } from '@store/user-review/actions';
import { apiUrls } from '@constants/api';
import { reviewSteps } from '@constants/review';
import API from '@utils/API';
import Logger from '@utils/Logger';
import Title from '@components/shared/Title';
import Text from '@components/shared/Text';
import Thumbnail from '@components/shared/Thumbnail';
import { confirmWrapper } from '@components/shared/AsyncConfirm';

function useCureFavorites(cure, needUnlikeConfirm, onUnlikeSuccess) {
  const dispatch = useDispatch();

  const user = useSelector(state => state.auth.user);
  const favourites_count = get(user, 'favourites_count', 0);

  const [isFavorited, setFavorited] = useState(cure.favourite);

  const confirmUnlikeConfig = {
    title: 'Are you sure you want to remove this item from favorites?',
    options: {
      acceptText: 'Yes, remove from favorites',
      declineText: 'No, keep it in favorites',
      inverted: true,
      children: (
        <div className="cure__unlike">
          <Text className="cure__unlike-subtitle">
            This item will be removed from your favorites list:
          </Text>
          {cure.thumbnail && (
            <Thumbnail
              src={cure.thumbnail}
              size="contain"
              className="cure__img"
            />
          )}
          <Title size="xs">{cure.name}</Title>
        </div>
      )
    }
  };

  const handleToggleFavorite = async () => {
    if (!user) {
      dispatch(setStep(reviewSteps.guestBanner));
      dispatch(toggleModal());
      return;
    }

    try {
      if (isFavorited) {
        if (needUnlikeConfirm) {
          const answer = await confirmWrapper(
            confirmUnlikeConfig.title,
            confirmUnlikeConfig.options
          );

          if (!answer) {
            return;
          }
        }
        await API.post(apiUrls.cures.removeFavorite(cure.slug));
        if (user) {
          onUnlikeSuccess && onUnlikeSuccess(cure);
          dispatch(setUser({ favourites_count: favourites_count - 1 }));
        }
      } else {
        await API.post(apiUrls.cures.favorite(cure.slug));
        if (user) {
          dispatch(setUser({ favourites_count: favourites_count + 1 }));
        }
      }

      setFavorited(!isFavorited);
    } catch (err) {
      Logger.error(err);
    }
  };

  return {
    isFavorited,
    handleToggleFavorite
  };
}

export { useCureFavorites };
